import React from 'react';
import { Box, Typography, Divider, Chip } from '@mui/material';
import uuLogo from '../../assets/uu-logo.png';

const UmangUtsavBanner = ({ location, receivers_count, venue, date }) => {
    return (
        <Box
            sx={{
                position: 'relative',
                borderRadius: 2,
                background: 'linear-gradient(90deg, #B9DDE5 0%, #FFC066 43%, #B9DDE5 92%)',
                overflow: 'hidden',
            }}
        >
            {/* Location chip — sits on top of both layers */}
            <Chip
                label={location}
                size="small"
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    bgcolor: '#333',
                    color: 'white',
                    height: 24,
                    borderRadius: 2,
                    fontFamily: 'Lato, sans-serif',
                    fontWeight: 600,
                    fontSize: 13,
                    lineHeight: '24px',
                    boxShadow: '0px 1px 2px rgba(0,0,0,0.1), 0px 1px 1px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.2)',
                }}
            />

            {/* Inner content card: overlaps the gradient with a translucent white surface */}
            <Box
                sx={{
                    borderRadius: 2,
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                }}
            >
                {/* Header row: logo + title/subtitle */}
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', pr: 10 }}>
                    <Box
                        component="img"
                        src={uuLogo}
                        alt="Umang Utsav Logo"
                        sx={{
                            width: 64,
                            height: 38,
                            borderRadius: '4px',
                            objectFit: 'cover',
                            flexShrink: 0,
                        }}
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                        <Typography variant="h3" sx={{ color: '#333' }}>
                            Umang Utsav
                        </Typography>
                        <Typography variant="p3" sx={{ color: '#666' }}>
                            Respect • Recognition • Reward
                        </Typography>
                    </Box>
                </Box>

                <Divider sx={{ borderColor: '#E0E0E0' }} />

                {/* Info rows */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    <Typography variant="labelM" sx={{ color: '#333' }}>
                        {receivers_count} Influencer{receivers_count !== '1' ? 's' : ''} invited
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Typography variant="labelM" sx={{ color: '#333', width: 50, flexShrink: 0 }}>
                            Venue:
                        </Typography>
                        <Typography variant="p3" sx={{ color: '#333', flex: 1 }}>
                            {venue}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Typography variant="labelM" sx={{ color: '#333', width: 50, flexShrink: 0 }}>
                            Date:
                        </Typography>
                        <Typography variant="p3" sx={{ color: '#333', flex: 1 }}>
                            {date}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default UmangUtsavBanner;
